import { generateTestId } from "@client-shared";

export const setUserNavTestId = (identifier: string): string => generateTestId("UserNav", identifier);

export const setUserNavVendorNameTestId = (): string => generateTestId("UserNav", "vendor-name");

export const setUserNavEmailTestId = (): string => generateTestId("UserNav", "email");

export const setUserNavLanguageSwitcherTestId = (identifier: string): string => generateTestId("UserNav", "language-switcher", identifier);

export const setUserNavLanguageButtonTestId = (locale: string): string =>
  generateTestId("UserNav", "language-button", locale.toLowerCase());

/** Set on the avatar button when the roaster can pick between languages; the tour's profile step anchors on it */
export const USER_NAV_MULTILINGUAL_ATTRIBUTE = "data-multilingual";
